import React, { useEffect, useMemo, useState } from "react"
import { colors, fonts, frames, glyphs, useMediaQuery } from "../../Styles/index"
import "../../Translations/index"
import { Button, ButtonList } from "../../Components"
import { NavigationFunction, Pages } from "../Routers/root"
import { useLocation, useNavigate } from "react-router"
import "../../Components/languageSelector"
import { StyleObject } from "styletron-react"
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next"
import { ButtonTypes, ListStyle_Types } from "../../Definitions"

interface TabMenu_Props {
  main:Pages,
  contexts:Pages[],
  overrides?:{
      gridArea?: string,
      base_alternative?: Pages
  }
}

export default function TabMenu({overrides, main, contexts}:TabMenu_Props) {
  const {t} = useTranslation()
  const navigator = useNavigate()
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>(contexts[0]);
  const [showTabs, setShowTabs] = useState<boolean>(false)
  const mobileXs = useMediaQuery(`(max-width: 690px)`);

  const BtnFunc_Router = (btn_Index:number) => {
    if (btn_Index === 0) {
      if (!overrides?.base_alternative) NavigationFunction(navigator, Pages.home, undefined, true)
      else NavigationFunction(navigator, main, overrides?.base_alternative, true)
    }
    else NavigationFunction(navigator, main, contexts[btn_Index-1])
  }

  const _context = ():string[] => {
    var texts:string[] = []
    // TODO: Maja, gøre det muligt at skrive et navn "manuelt" for tab'en
    
    // texts.push(t("globalMenu." + main))
    // contexts.forEach(text => {
    //   var test = t("subMenu." + main + "." + text)
    //   texts.push(test.startsWith("subMenu")?text:test)
    // })
    // return texts
    texts.push(t(`globalMenu.${main}`, {defaultValue: main}))
    contexts.forEach(text => {
      var subText = t(text)
      texts.push(subText.startsWith("subMenu")?text:subText)
    })
    return texts
  }

  // Update active tab based on current URL path
  useEffect(() => {
    const pathParts = location.pathname.split("/");
    const activeContext = pathParts[pathParts.length - 1];
    setActiveTab(activeContext || contexts[0]);
  }, [location.pathname, contexts]);

  // Toggle tabs
  const toggleComponents = () => {
    setShowTabs(!showTabs)
  };

  // Reset showTabs to false when the location changes
  useEffect(() => {
    setShowTabs(false);
  }, [location]);
  
  // _Root Overrides (Grid Area)
  const _Root = useMemo<StyleObject>(() => {
    return Object.assign(
        {} as StyleObject,
        overrides&&overrides.gridArea? {gridArea:overrides.gridArea} : {}
    )
  },[overrides])
  
  return (
    <frames.Page_outer>
      <frames._page_outer_tabMenu>
        <frames.TabMenu $style={_Root}>
          { mobileXs? <></> :
          <ButtonList 
            contents={_context()}
            onClick={(e) => BtnFunc_Router(e)}
            buttonType={ButtonTypes.tabButton}
            hasActiveLoad={true}
            overrides={(index) => ({
              baseButton: {
                borderRadius: index === 0 ? "0px 8px 0px 0px" : "8px 8px 0px 0px"
              }
            })}
            listOverrides={{
              useNavigationControl: "tab",
              listStyle: ListStyle_Types.horizontal,
              listGap: "5px"
            }}
          /> 
          }
        </frames.TabMenu>

        {/* TabMenu bottom line */}
        { mobileXs? <></> : <div style={{height: "5px", backgroundColor: colors.blueDarkPrimary, position: "sticky", left: "0px", right: "0px"}}></div> }
      </frames._page_outer_tabMenu>
      
      {/* TabMenu Btn on Mobile */}
      { mobileXs?
        <div style={{position: "absolute", right: "0px", bottom: "10px"}}>
          <Button content={t(`subMenu.${activeTab}`, { defaultValue: activeTab })} 
            onClick={toggleComponents} 
            overrides={{
              baseButton: {
                width:"fit-content", 
                minWidth: "60px",
                height: "60px", 
                backgroundColor: colors.blueDarkPrimary+"cc", 
                borderStyle: "solid",
                borderColor: colors.blueDarkPrimary,
                borderWidth: "0px 2px 2px 2px",
                borderRadius: "10px 0px 0px 10px",
                zIndex: "999",
                backdropFilter: "blur(2px)"
              },
              hoverStyles: {
                backgroundColor: colors.blueDarkPrimary+"cc", 
              }
            }}
          />
        </div>
      : <></> }
      {/* TabMenu on Mobile */}
      {showTabs && <>
        <div style={{ backgroundColor: "black", opacity: "0.5", position: "absolute", top: 0, left: 0, bottom: 0, right: 0, zIndex: "99999"}}/>
        <div style={{position: "absolute", inset: "10px", display: "flex", flexDirection: "column", alignItems: "end", justifyContent: "end", gap: "5px", zIndex: "999999", margin: "0 auto", maxWidth: "550px"}}>
          <div onClick={toggleComponents} style={{cursor: "pointer"}}><glyphs.Close size="25px"/></div>
          <div style={{backgroundColor: colors.greyDarkPrimary, borderWidth: "10px 1px", borderStyle: "solid", borderColor: colors.greyDarkPrimary, borderRadius: "10px", width: "100%", height: "fit-content", boxShadow: "0px 0px 5px 2px"+colors.blackPrimary+"4d", maxHeight: "100%", overflowY: "scroll", padding: "0px 9px", boxSizing: "border-box", scrollbarWidth: "thin", scrollbarColor: colors.greyDarkSecondary+colors.transparent}}>
            <ButtonList 
              contents={_context()}
              onClick={(e) => BtnFunc_Router(e)}
              hasActiveLoad={true}
              overrides={{
                baseButton: {justifyContent: "start", width: mobileXs? "100%" : "270px"},
                hoverStyles: {backgroundColor: colors.blueDarkPrimary},
                contentStyles: {textAlign: "left"},
                subContentStyles: {textAlign: "left", color: colors.greyPrimary}
              }}
              listOverrides={{
                useNavigationControl: "tab",
                listStyle: ListStyle_Types.vertical,
                listWidth: "100%"
              }}
            />
          </div>
        </div>
      </> }
      <frames._page_outer_inner_page>
        <Outlet/>
      </frames._page_outer_inner_page>
    </frames.Page_outer>
  )
}
